(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-produits-moteurs"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function init(root) {
      if (root.dataset.vmvrInit === '1') return;
      root.dataset.vmvrInit = '1';

      var brandTabs = root.querySelectorAll('[data-vmvr-brand-tab]');
      var panels    = root.querySelectorAll('[data-vmvr-panel]');

      brandTabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          var brandId = tab.getAttribute('data-vmvr-brand-tab');

          brandTabs.forEach(function(t) {
            var active = t === tab;
            t.classList.toggle('is-active', active);
            t.setAttribute('aria-selected', active ? 'true' : 'false');
          });

          panels.forEach(function(p) {
            var active = p.getAttribute('data-vmvr-panel') === brandId;
            p.classList.toggle('is-active', active);
            if (active) {
              p.removeAttribute('hidden');
            } else {
              p.setAttribute('hidden', '');
            }
          });
        });
      });

      panels.forEach(function(panel) {
        var typeTabs = panel.querySelectorAll('[data-vmvr-type]');
        var cards    = panel.querySelectorAll('[data-vmvr-card]');

        typeTabs.forEach(function(t) {
          t.addEventListener('click', function() {
            var type = t.getAttribute('data-vmvr-type');

            typeTabs.forEach(function(x) {
              var active = x === t;
              x.classList.toggle('is-active', active);
              x.setAttribute('aria-selected', active ? 'true' : 'false');
            });

            cards.forEach(function(card) {
              var cardType = card.getAttribute('data-product-type');
              var show = (type === 'all') || (cardType === type);
              if (show) {
                card.removeAttribute('hidden');
              } else {
                card.setAttribute('hidden', '');
              }
            });
          });
        });
      });
    }

    document.querySelectorAll('[data-vmvr-root]').forEach(init);
    document.addEventListener('shopify:section:load', function(e) {
      var root = e.target.querySelector('[data-vmvr-root]');
      if (root) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
